export default __webpack_public_path__ + "static/loupe-design-system-cover-2966450b8957cff89b6720047f4f75d5.png";